import {createStore, applyMiddleware, compose} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {persistReducer,persistStore} from 'redux-persist';

import rootReducer from './reducers';
import rootSaga from './sagas';
import localforage from 'localforage';


const sagaMiddleware = createSagaMiddleware();


const persistConfig = {
    key: 'root',
    storage: localforage,
    whitelist: ['login'],
    timeout: 0,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, 
    compose(
        applyMiddleware( sagaMiddleware),    
        (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && 
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__())|| compose,
    )
);
sagaMiddleware.run(rootSaga);
const persistor = persistStore(store);
store.persistor = persistor;
export {store,persistor}